import { render, staticRenderFns } from "./pageBase.vue?vue&type=template&id=cde0398a"
import script from "./pageBase.vue?vue&type=script&lang=js"
export * from "./pageBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports